import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from 'antd';
import styled from 'styled-components';
import Papa from 'papaparse';

import Step from 'components/atoms/Step';
import CourseDetail from './CourseDetail/index';
import InviteInstructor from './InviteInstructor/index';
import RegisterStudents from './RegisterStudents/index';
import Review from './Review/index';
import { DownloadFileFromURL } from 'utils/helper';
import { PageContext } from './PageProvider';
import courseRequest from 'services/course';
import adminRequests from 'services/admin';

const { Title } = Typography;

const Container = styled.div`
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    min-height: 100%;
    padding: 30px;
    width: 100%;
`;

const ContentWrapper = styled.div``;

const PanelsContainer = styled.div`
    display: flex;
`;

const PanelContainer = styled.div`
    margin-right: 12px;
`;

const CreateCoursePage = () => {
    const history = useHistory();
    const { reviewData, setReviewData } = useContext(PageContext);

    const [cdComplete, setCDComplete] = useState(false);
    const [iiComplete, setIIComplete] = useState();
    const [rsComplete, setRSComplete] = useState();

    const downloadCSV = ({ course, instructors, students }) => {
        const courseText = Papa.unparse(
            [course].map((item) => ({
                'school name': item.school,
                faculty: item.faculty,
                'course name': item.name,
                section: item.section,
                semester: item.semester,
            })),
            { header: true }
        );
        const instructorText = Papa.unparse(
            instructors.map((item) => ({
                'instructor name': item.name,
                username: item.username,
                password: item.password,
            })),
            { header: true }
        );
        const studentText = Papa.unparse(
            students.map((item) => ({
                'student id': item.studentId,
                'student name': item.name,
                group: item.group,
                username: item.studentId,
                password: item.password,
                record: item.record,
            })),
            { header: true }
        );
        const csvText = courseText + '\n' + instructorText + '\n' + studentText;
        const blob = new Blob([csvText], { type: 'text/plain;charset=utf-8' });
        const downloadUrl = URL.createObjectURL(blob);
        DownloadFileFromURL(downloadUrl, 'accounts.csv');
    };

    const handleSubmitDetail = () => {
        setCDComplete(true);
        if (iiComplete !== true) {
            setIIComplete(false);
            return;
        }
        if (rsComplete !== true) setRSComplete(false);
    };

    const handleSubmitInstructors = () => {
        setIIComplete(true);
        if (cdComplete !== true) {
            setCDComplete(false);
            return;
        }
        if (rsComplete !== true) setRSComplete(false);
    };

    const handleSubmitStudents = () => {
        setRSComplete(true);
        if (cdComplete !== true) {
            setCDComplete(false);
            return;
        }
        if (iiComplete !== true) setIIComplete(false);
    };

    const handleSubmitReview = async (download) => {
        try {
            // const course = await postRequest(ADMIN.CREATE_COURSE, reviewData.course);
            const course = await adminRequests.createCourse({ ...reviewData.course, finished_course_set_up: false });
            await courseRequest.upsertCourseDraft(course.id, {
                active: true,
                course_id: course.id,
                created_on: new Date().getTime(),
                modified_on: new Date().getTime(),
                school: course.school,
                course_name: course.name,
                faculty: course.faculty,
                semester: course.semester,
                section: course.section,
            });
            await adminRequests.createInstructors({
                course_id: course.id,
                instructors: reviewData.instructors,
            });
            await adminRequests.createStudents({
                course_id: course.id,
                students: reviewData.students,
            });

            if (download) downloadCSV(reviewData);

            history.push('/');
        } catch (err) {
            console.log(err);
        }
    };

    const handleEditDetail = () => {
        setCDComplete(false);
        if (iiComplete === false) setIIComplete(null);
        if (rsComplete === false) setRSComplete(null);
    };

    const handleEditInstructors = () => {
        setIIComplete(false);
        if (cdComplete === false) setCDComplete(null);
        if (rsComplete === false) setRSComplete(null);
    };

    const handleEditStudents = () => {
        setRSComplete(false);
        if (cdComplete === false) setCDComplete(null);
        if (iiComplete === false) setIIComplete(null);
    };

    return (
        <Container>
            <ContentWrapper>
                <Title level={3} style={{ marginBottom: 40 }}>
                    Create new course
                </Title>
                <PanelsContainer>
                    <PanelContainer>
                        <Step
                            number={1}
                            text='Course'
                            active={cdComplete === false}
                            complete={cdComplete === true}
                            style={{ marginBottom: 12 }}
                        />
                        <Step
                            number={2}
                            text='Instructors'
                            active={iiComplete === false}
                            complete={iiComplete === true}
                            style={{ marginBottom: 12 }}
                        />
                        <Step
                            number={3}
                            text='Students'
                            active={rsComplete === false}
                            complete={rsComplete === true}
                            style={{ marginBottom: 12 }}
                        />
                        <Step number={4} text='Review' active={cdComplete && iiComplete && rsComplete} />
                    </PanelContainer>

                    <div>
                        <CourseDetail complete={cdComplete} onEdit={handleEditDetail} onSubmit={handleSubmitDetail} />
                        {iiComplete !== undefined && (
                            <InviteInstructor
                                complete={iiComplete}
                                onEdit={handleEditInstructors}
                                onSubmit={handleSubmitInstructors}
                            />
                        )}
                        {rsComplete !== undefined && (
                            <RegisterStudents
                                data={reviewData}
                                complete={rsComplete}
                                onEdit={handleEditStudents}
                                onSubmit={handleSubmitStudents}
                            />
                        )}
                        {cdComplete && iiComplete && rsComplete && (
                            <Review data={reviewData} onSubmit={handleSubmitReview} />
                        )}
                    </div>
                </PanelsContainer>
            </ContentWrapper>
        </Container>
    );
};

export default CreateCoursePage;

/*
  true => completed
  false => open
  undefined => not started
  null => in progress
*/
